import { UPDATE_APP_SHELL_DATA } from './action-creators';
export default (state, action) => {
    switch (action.type) {
        case UPDATE_APP_SHELL_DATA:
            return action.appShellData;
        default:
            return state;
    }
};
